import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import UnitFeature from './unitFeatures';
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import ImagesViewList from './imageVIew';
import { useTranslation } from 'react-i18next';

const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const ViewUnitMaster = ({ rowData, onClose }) => {
    const { t } = useTranslation();
    const apiService = new LeaseApiService();
    const userName = useSelector(getName);
    const [activeFY, setActiveFY] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false,]);
    const [loading, setloader] = useState(false)
    // Master Listings
    const [tableLoading, setTableLoading] = useState(false);
    // Unit Listings
    const [attachments, setAttachments] = useState([]);
    const [featuresList, setFeaturesList] = useState([]);
    const [supplierCheck, setSupplierCheck] = useState("");
    const leaseData = rowData;
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    const [transectionData, setTransectionData] = useState({
        property: null,
        unitType: null,
        unitCategory: null,
        contactPerson: null,
        unitNo: '',
        roundoff: '',
        notes: '',
        totalvalue: '',
        mobile: '',
    });
    const [unitDetails, setUnitDetails] = useState({
        bedRooms: null,
        unitView: null,
        furnishing: null,
        utilityRoom: '',
        studyRoom: '',
        laundryRoom: '',
        maidRoom: '',
        storeRoom: '',
        plotNO: '',
        bathRoom: '',
        plotSize: '',
        parking: '',
        balcony: '',
        parkingPrice: '',
        totalArea: '',
        sqftRate: '',
        allPrice: '',
        registrationFee: '',
        completionDate: formattedDate,
    });
    const [salesDetails, setSalesDetails] = useState({
        currency: null,
        orignalPrice: '',
        orignalRateSqft: '',
        profit: '',
        profitCalculate: '',
        listingPrice: '',
        listingPriceRate: '',
        priceinothercontry: '',
        mainSalePrice: '',
        marketAnalysis: '',
        to: '',
        commPaid: '',
        commPaidCalculate: '',
        commSeller: '',
        commSellerCalculate: '',
        sellerTransferFee: '',
        sellerTransferFeeCalcu: '',
        buyerTransferFee: '',
        buyerTransferFeeCalcu: '',
        legalFee: '',
        legalFeeCalcu: '',
        miscFee: '',
        miscFeeCalcu: '',
        comment: '',
        sellerPaidDev: '',
        sellerPaidDevCalcu: '',
        amountDueDev: '',
        amountDueDevCalcu: '',
    });
    const [buyerSummery, setBuyerSummery] = useState({
        sellerTransfer: '',
        developerBalance: '',
        developerBalancePerc: '',
        BuyerCommission: '',
        BuyerCommissionPerc: '',
        DlDTransfer: '',
        DlDTransferPerc: '',
        administrationFee: '',
        administrationFeePerc: '',
        otherFee: '',
        otherFeePerc: '',
        allPrice: '',
        allPricePerc: '',
    });
    const [leaseDetails, setLeaseDetails] = useState({
        dueDate: formattedDate,
        rentPerAnum: '',
        rentByMonth: '',
        rentPerDay: '',
        securityDeposit: '',
        securityDepositPerc: '',
        tenantCommission: '',
        tenantCommissionPerc: '',
        landlordCommission: '',
        landlordCommissionPerc: '',
        maintenanceFee: '',
        rentPayable: '',
        IbanNo: '',
        secDepositPayable: '',
        commissionPayable: '',
        bankName: null,
        accountNo: '',
        fixedCharges: '',
        variableCharges: '',
        installment: '',
    });

    useEffect(() => {
        fetchDropdownData()
    }, []);
    const fetchDropdownData = async () => {
        try {
            if (leaseData) {
                const params = new URLSearchParams();
                params.append('Action', 'GetUnitDetailsByRefNo');
                params.append('UnitRefNo', leaseData?.ref_No);
                const unitres = await apiService.getApiParamater('UNIT_RA_COMMON', `?${params.toString()}`);
                let unitData = unitres?.data?.result?.data
                setTransectionData({
                    property: { label: leaseData?.property_No, value: leaseData?.property_No },
                    unitType: { label: leaseData?.unit_Type, value: leaseData?.unit_Type },
                    unitCategory: { label: leaseData?.unit_Category, value: leaseData?.unit_Category },
                    contactPerson: { label: unitData?.Broker_Name, value: unitData?.Broker_Name },
                    unitNo: leaseData?.unit_No || '',
                    roundoff: leaseData?.roundOff_Value || '',
                    notes: leaseData?.remarks || '',
                    totalvalue: leaseData?.total_Value || '',
                    mobile: '',
                });
                setUnitDetails({
                    bedRooms: { label: leaseData?.bedrooms, value: leaseData?.bedrooms },
                    unitView: { label: leaseData?.unit_View, value: leaseData?.unit_View },
                    furnishing: { label: unitData?.Facilities, value: unitData?.Facilities },
                    floor: { label: unitData?.floor, value: unitData?.floor },
                    utilityRoom: unitData?.Street_No || '',
                    studyRoom: unitData?.FinanceCompany || '',
                    laundryRoom: unitData?.Street_Name || '',
                    maidRoom: unitData?.StoreRooms || '',
                    storeRoom: leaseData?.storeRooms || '',
                    plotNO: leaseData?.plot_No || '',
                    bathRoom: unitData?.Bathrooms || '',
                    plotSize: leaseData?.plot_Size || '',
                    parking: leaseData?.parking || '',
                    balcony: unitData?.Balcony || '',
                    parkingPrice: leaseData?.parking_Price || '',
                    totalArea: leaseData?.total_Area || '',
                    sqftRate: leaseData?.sqft_Rate || '',
                    allPrice: leaseData?.all_In_Price || '',
                    registrationFee: unitData?.Buyer_TransferFee || '',
                    completionDate: unitData?.completion_Date,
                    rent: unitData?.Rent_Per_Annum,
                });
                setSupplierCheck(unitData?.Leased === true ? "Lease" : "Sale")
                // Same source as the edit page (Lease Finance unit images), so every uploaded image, PDF and video shows here.
                const imagesParam = new URLSearchParams();
                imagesParam.append('Action', 'GetUnitImagesByRefNo');
                imagesParam.append('UnitRefNo', leaseData?.ref_No);
                const imgResp = await apiService.getApiParamater('UNIT_RA_COMMON', `?${imagesParam.toString()}`);
                const imgData = imgResp?.data?.result?.data;
                const imgList = Array.isArray(imgData) ? imgData : imgData?.record_Id ? [imgData] : [];
                if (imgList.length) {
                    setAttachments(imgList.map((item) => ({
                        id: item.record_Id,
                        record_Id: item.record_Id,
                        fileName: item.image_Filename,
                        remarks: item.image_Description && item.image_Description !== '0' ? item.image_Description : '',
                        fullUrl: item.url,
                    })));
                } else {
                    const fileparams = new URLSearchParams();
                    fileparams.append('refNo', leaseData?.ref_No);
                    fileparams.append('fileCategory', "Images");
                    const imgRes = await apiService.getApiParamater('GET_FILE', `?${fileparams.toString()}`);
                    setAttachments(imgRes?.data?.result || [])
                }

            }
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleBackClick = () => {
        if (onClose) onClose();
    }
    return (
        <div className="d-flex flex-column unit-modal-form" style={{ height: '85vh' }}>
            <div className="p-3 border-bottom d-flex align-items-center justify-content-between flex-shrink-0">
                <h5 className="mb-0">{t('unitMaster.viewFormTitle')}</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={handleBackClick}></button>
            </div>
            <div className="p-3" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4 unit-modal-tabs'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>{t('unitMaster.tabs.propertyDetails')}
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}>{t('unitMaster.tabs.unitDetails')}
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)}>{t('unitMaster.tabs.unitFeatures')}
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 7 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(7)}>{t('unitMaster.tabs.images')}
                    </div>
                </div>
            </div>
            {/* Lease Details */}
            {gridVisibility[0] && (
                <div className="cost-center-section my-3">
                    <div className={`border-box2 p-3`}>
                        {tableLoading && (
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    background: 'rgba(255,255,255,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 10,
                                }}
                            >
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        )}
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>

                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('unitMaster.masterDetailsFields.property')} *</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={transectionData?.property}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> {t('unitMaster.masterDetailsFields.mobileNo')}</label>
                                <input type="text" className="p-2 form-control w-75" value={transectionData?.mobile} readOnly name="mobile" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.masterDetailsFields.totalValue')}</label>
                                <input type="number" className="p-2 form-control w-75" value={transectionData?.totalvalue} readOnly name="totalvalue" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> {t('unitMaster.masterDetailsFields.unitNo')} *</label>
                                <input type="text" className="p-2 form-control w-75" value={transectionData?.unitNo} readOnly name="unitNo" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('unitMaster.masterDetailsFields.contactPerson')}</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={transectionData?.contactPerson}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.masterDetailsFields.roundOffValue')} *</label>
                                <input type="text" className="p-2 form-control w-75" value={transectionData?.roundoff} readOnly name="roundoff" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom22" className="form-label">{t('unitMaster.masterDetailsFields.unitType')} *</label>
                                <Select className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={transectionData?.unitType}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.masterDetailsFields.unitCategory')} *</label>
                                <Select className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={transectionData?.unitCategory}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.masterDetailsFields.notes')}</label>
                                <input type="text" className="p-2 form-control w-75" value={transectionData?.notes} readOnly name="notes" />
                            </div>
                        </div>
                    </div>
                </div >)}
            {gridVisibility[1] && (
                <div className="cost-center-section my-3">
                    <div className={`border-box2 p-3`}>
                        {tableLoading && (
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    background: 'rgba(255,255,255,0.6)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 10,
                                }}
                            >
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        )}

                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.utilityRoom')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.utilityRoom} readOnly name="utilityRoom" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom22" className="form-label">{t('unitMaster.unitDetailsFields.furnished')}</label>
                                <Select className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={unitDetails?.furnishing}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.studyRoom')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.studyRoom} readOnly name="studyRoom" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.laundryRoom')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.laundryRoom} readOnly name="laundryRoom" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.maidRoomEnsuite')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.maidRoom} readOnly name="maidRoom" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> {t('unitMaster.unitDetailsFields.plotNo')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.plotNO} readOnly name="plotNO" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.bedrooms')}</label>
                                <Select className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={unitDetails?.bedRooms}
                                    readOnly
                                />
                            </div>
                            <div className='d-flex gap-3'>
                                <div className="form-check gap-3 center">
                                    <input style={{ width: "20px", height: "20px" }} readOnly checked={supplierCheck === "Sale" ? true : false}
                                        className="form-check-input" type="radio" name="flexRadioDefault" id={supplierCheck} />
                                    <label className="form-check-label" for="Sale">{t('unitMaster.unitDetailsFields.sale')}</label>
                                </div>
                                <div className="form-check gap-3 center" >
                                    <input className="form-check-input" style={{ width: "20px", height: "20px" }} readOnly
                                        type="radio" name="flexRadioDefault" id={supplierCheck} checked={supplierCheck === "Lease" ? true : false}
                                    />
                                    <label className="form-check-label" for="Lease">{t('unitMaster.unitDetailsFields.lease')}</label>
                                </div>
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.plotSize')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.plotSize} readOnly name="plotSize" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.bathroom')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.bathRoom} readOnly name="bathRoom" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.unitView')} *</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={unitDetails?.unitView}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.noOfParkings')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.parking} readOnly name="parking" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.floor')}</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={unitDetails?.floor}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.balconyArea')}</label>
                                <input type="email" className="p-2 form-control w-75" value={unitDetails?.balcony} readOnly name="balcony" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.parkingPrice')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.parkingPrice} readOnly name="parkingPrice" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.totalArea')} *</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.totalArea} readOnly name="totalArea" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.sqftRate')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.sqftRate} readOnly name="sqftRate" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.allInPrice')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.allPrice} readOnly name="allPrice" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.completionDate')}</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={unitDetails?.completionDate}
                                    readOnly
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.registrationFees')}</label>
                                <input type="number" className="p-2 form-control w-75" value={unitDetails?.registrationFee} readOnly name="registrationFee" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.rentPerAnnum')}</label>
                                <input type="text" className="p-2 form-control w-75" value={unitDetails?.rent} readOnly name="rent" />
                            </div>
                        </div>
                    </div>
                </div>)}
            {gridVisibility[2] && (<UnitFeature tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />)}
            {gridVisibility[7] && (<ImagesViewList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />)}
            </div>
            <div className="p-3 border-top d-flex justify-content-start gap-3 flex-shrink-0">
                <div className='mainbtn flex-end gap-2' onClick={handleBackClick}>
                    <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                    <div className='center'>{t('common.close')}</div>
                </div>
            </div>
        </div>
    );
};
export default ViewUnitMaster;